export const mobileLinesModalNavigationProps = {
  historyBackOnClose: false,
  onCloseHandler: () => {
    if (typeof window !== 'undefined' && window.location.hash === '#MobileLinesModal') {
      // El cierre solo cambia el ancla; no debe rehidratar el configurador.
      window.history.replaceState(
        window.history.state,
        '',
        `${window.location.pathname}${window.location.search}`,
      );
    }
  },
};
